import DealCalculator from '../DealCalculator';

const InvestmentsDirectIdDealCalculatorNewCalculation = () => {
  return <DealCalculator />;
};

export default InvestmentsDirectIdDealCalculatorNewCalculation;
